module.exports = __webpack_public_path__ + "img/extracts.146f08a7.svg";